// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1553":"fd608de4","4839":"5af819e7","8678":"160d793d"}[chunkId] + ".chunk.css";
};